import AdminLayout from "../../components/AdminLayout";
import Payment from "./Payment";

const PaymentPage = () => {
    return (
        <AdminLayout>
            <Payment />
        </AdminLayout>
    );
};

export default PaymentPage;